module.exports = __webpack_public_path__ + "static/media/certdeser.b2017510.png";